export const getAuth = async (initDataRaw: string): Promise<string> => {
  const response = await fetch(`${import.meta.env.VITE_API}/token`, {
    headers: {
      Authorization: `Bearer ${initDataRaw}`,
    },
  })

  const data = await response.json()

  const token = data?.token
  if (token) return token
  else return Promise.reject(new Error(`Failed to authorize user`))
}
